module.exports = __webpack_public_path__ + "assets/menu-empty-search-d8fa4e.svg";